<script setup>
	import { ref, watch } from 'vue'
const props = defineProps({
	imgSize: {
		default: 0
	},
	cols: {
		default: 0
	},
	col: {
		default: 0
	},
	contentMargin: {
		default: 0
	},
	imgRadius: {
		default: 8
	},
	item: {
		default: {}
	},
	itemBgColor: {
		default: '#fff'
	},
	priceColor: {
		default: '#999999'
	},
	titleColor: {
		default: '#333333'
	},
	soldColor: {
		default: '#999999'
	},
	exhibition: {
		default: 'waterfall'
	},
})
// 计算瀑布流间距 手动计算容易出bug所有注释掉了
function getMargin() {
	return {
		"border-radius": `${props.imgRadius}rpx`
	}
}
const priceStyle = ref({
	color: props.priceColor
})
const titleStyle = ref({
	color: props.titleColor
})

function handleClick() {
	let id = props.item.id;
	if(props.item.id == null) {
		id = props.item.contentId;
	}
	uni.navigateTo({
		url: "/pageC/college/college?id="+id
	})
}
</script>

<template>
	<view class="fulled relative" @click="handleClick">
		<view class="item-box" v-if="exhibition=='waterfall'" :style="getMargin()">
			<view :style="{'width': '100%','height': imgSize+'rpx', 'border-radius': imgRadius+'rpx'}">
				<image :src="item.img" mode="aspectFill" :style="{'width': '100%','height': imgSize+'rpx', 'border-radius': imgRadius+'rpx'}"></image>
			</view>
			<view style="margin-top: 16rpx;">
				<wd-text :color="titleColor" size="28rpx" :lines="1" :text="item.name"></wd-text>
			</view>
		</view>
		<view class="o-flex-r-s-s" v-else>
			<wd-img :width="`${222}rpx`" :height="`${222}rpx`" radius="8rpx" mode="aspectFill" :src="item.img"></wd-img>
			<view class="o-flex-c-b-s flex-1" style="margin-left: 24rpx;">
				<view style="width: 100%;">
					<wd-text :color="titleColor" size="32rpx" bold :lines="2" lineHeight="44rpx" :text="item.name"></wd-text>
					<wd-text :color="priceColor" size="26rpx" :lines="2" lineHeight="36rpx" style="margin-top: 6rpx;" :text="item.about"></wd-text>
				</view>
				<view class="o-flex-r-s-c">
					<uni-icons fontFamily="iconfont" size="34rpx" :color="soldColor">&#xe653;</uni-icons>
					<wd-text :color="soldColor" size="26rpx" style="margin-left: 6rpx;" :text="item?.readNumTotal == null ? 0 : item?.readNumTotal"></wd-text>
				</view>
			</view>
		</view>
	</view>
</template>

<style lang="scss">

</style>